import React from "react";
import { Link } from "react-router-dom";
import { CONTACT_EMAIL, LINKEDIN_URL, CTA_LABEL } from "@/config/site";

const PAGES = [
  { label: "Outbound Engine Build", path: "/outbound-engine-build" },
  { label: "Custom Workflows", path: "/custom-workflows" },
  { label: "Industries", path: "/industries" },
  { label: "Workflow Library", path: "/workflows" },
  { label: "Insights", path: "/insights" },
  { label: CTA_LABEL, path: "/audit" },
];

const MORE = [
  { label: "Referral Program", path: "/referral" },
  { label: "Terms of Service", path: "/terms" },
  { label: "Privacy Policy", path: "/privacy" },
];

const slug = (label) => label.toLowerCase().replace(/ /g, "-");

export default function FooterSection() {
  return (
    <footer className="bg-[#3D472D] px-6 sm:px-8 pt-16 pb-10" data-testid="footer">
      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-3 gap-12 mb-14">
          <div>
            <Link to="/" className="font-fraunces font-extrabold text-xl text-[#F4E9D8] inline-block mb-3">
              Raki Solutions<span className="text-[#C8703A]">.</span>
            </Link>
            <p className="text-sm text-[#F4E9D8]/65 leading-relaxed max-w-xs">
              Raki Solutions, Singapore. AI sales workflows built around how you sell.
            </p>
          </div>

          <div>
            <h2 className="font-semibold text-sm text-[#F4E9D8] mb-4">Pages</h2>
            <ul className="space-y-2.5 text-sm text-[#F4E9D8]/65">
              {PAGES.map((p) => (
                <li key={p.path}>
                  <Link to={p.path} className="hover:text-[#C8703A] transition-colors" data-testid={`footer-link-${slug(p.label)}`}>
                    {p.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h2 className="font-semibold text-sm text-[#F4E9D8] mb-4">More</h2>
            <ul className="space-y-2.5 text-sm text-[#F4E9D8]/65">
              {MORE.map((l) => (
                <li key={l.path}>
                  <Link to={l.path} className="hover:text-[#C8703A] transition-colors" data-testid={`footer-link-${slug(l.label)}`}>
                    {l.label}
                  </Link>
                </li>
              ))}
              <li>
                <a href={LINKEDIN_URL} target="_blank" rel="noopener noreferrer" className="hover:text-[#C8703A] transition-colors" data-testid="footer-linkedin">
                  LinkedIn
                </a>
              </li>
              <li>
                <a href={`mailto:${CONTACT_EMAIL}`} className="hover:text-[#C8703A] transition-colors" data-testid="footer-email">
                  {CONTACT_EMAIL}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-[#F4E9D8]/15 pt-7">
          <p className="text-xs text-[#F4E9D8]/50" data-testid="footer-copyright">
            &copy; {new Date().getFullYear()} Raki Solutions, Singapore.
          </p>
        </div>
      </div>
    </footer>
  );
}
